export default {
    close: 'Fechar',
    error: 'Ocorreu um erro.',

    bill: {
        archive: {
            label: 'Arquivar',
            title: 'Arquivar Fatura',
            p1:
                'Atenção ao arquivar essa fatura o sistema irá cancelar a cobrança no gateway de pagamento e ela ficará oculta na listagem.',
            p2:
                'Caso queira visualiza-la posteriormente, utilize o filtro "Exibir Arquivadas".',
            perform: 'Arquivar',
            success: 'Fatura arquivada com sucesso.',
        },

        cancelCharging: {
            label: 'Cancelar Cobrança',
            title: 'Cancelar Cobrança',
            text:
                'Essa ação irá excluir a cobrança no Gateway de Pagamento. Tem certeza que deseja prosseguir ?',
            perform: 'Prosseguir',
            success: 'Cobrança de fatura cancelada com sucesso.',
        },

        negotiate: {
            label: 'Parcelar Fatura',
            title: 'Parcelamento de Fatura',
            text:
                'Ao realizar o parcelamento, a cobrança desta fatura será cancelada e o valor da parcela será adicionada às próximas faturas a partir da referência selecioanda abaixo.',
            perform: 'Parcelar',
            success: 'Parcelamento realizado com sucesso',
        },

        nfPage: {
            label: 'Acessar NF',
        },

        paymentPage: {
            label: 'Página de Pagamento',
        },

        recalculate: {
            label: 'Recalcular',
            title: 'Recalcular Fatura',
            text: 'Tem certeza que deseja recalcular está fatura ?',
            perform: 'Recalcular',
            success: 'Fatura recalculada com sucesso.',
        },

        sync: {
            label: 'Sincronziar',
            success: 'Fatura sincronizada com sucesso.',
        },

        transmit: {
            label: 'Transmitir',
            title: 'Transmitir',
            text:
                'Ao realizar a transmissão da fatura, ela será enviada para o gateway de pagamento e o parceiro receberá a cobrança.',
            confirmText: 'Tem certeza que deseja prosseguir ?',
            perform: 'Prosseguir',
            success: 'Fatura transmitida com sucesso.',
        },

        unarchive: {
            label: 'Desarquivar',
            title: 'Desarquivar Fatura',
            p1:
                'Atenção ao desarquivar a fatura ela voltará a ser listada por padrão, porém para retomar a cobrança dela você deverá transmiti-la manualmente.',
            perform: 'Desarquivar',
            success: 'Fatura desarquivada com sucesso.',
        },
    },

    customer: {
        cancellationRequisition: {
            label: 'Solicitação de Cancelamento Pendente',
            title: 'Solicitação de Cancelamento',
            approve: 'Efetuar Cancelamento',
            decline: 'Reativar Cliente',
        },
        cancellationRequisitionLimitDay: {
            label: 'Solicitar Cancelamento',
            title: 'Solicitação de Cancelamento',
            approve: 'Solicitar e Efetuar Cancelamento',
            decline: 'Cancelar',
        },
        changeReseller: {
            label: 'Trocar de parceiro',
            title: 'Trocar de parceiro',
            text:
                'Atenção, você está prestes a transferir este cliente para outro parceiro. Tem certeza de que deseja prosseguir?',
            perform: 'Confirmar',
            success: 'Uma solicitação de migração foi criada.',
        },
        sendResearch: {
            label: 'Enviar pesquisa de satisfação',
            title: 'Enviar pesquisa de satisfação',
            text: 'Deseja enviar uma pesquisa de satisfação para o cliente?',
            perform: 'Enviar',
            success: 'Pesquisa de satisfação enviada.',
        },
        erpSync: {
            label: 'Sincronizar Dados com ERP',
            title: 'Sincronizar Dados com o ERP',
            text: 'Tem certeza que deseja realizar a sincronização ?',
            perform: 'Sincronizar',
            success: 'Sincronizado com sucesso.',
        },
    },

    lead: {
        changeReseller: {
            label: 'Trocar de parceiro',
            title: 'Trocar de parceiro',
            text:
                'Atenção, você está prestes a transferir este prospect para outro parceiro. Tem certeza de que deseja prosseguir?',
            perform: 'Confirmar',
            success: 'Prospect transferido com sucesso.',
        },
    },

    period: {
        commissionIt: {
            label: 'Comissionar Período',
            success: 'Período comissionado com sucesso.',
        },
        decommissionIt: {
            label: 'Descomissionar Período',
            success: 'Período descomissionado com sucesso.',
        },
        toNextCommission: {
            label: 'Enviar para a próxima comissão',
            success: 'Período enviado para a próxima comissão com sucesso.',
        },
        toPreviousCommission: {
            label: 'Enviar para a comissão anterior',
            success: 'Período enviado para a comissão anterior com sucesso.',
        },
    },

    reseller: {
        activate: {
            label: 'Ativar Parceiro',
            title: 'Confirmar Ativação ?',
            text: 'Tem certeza que deseja ativar o parceiro: <b>{name}</b> ?',
            success: 'Ativação do parceiro em andamento.',
        },

        fixCategory: {
            label: 'Categoria Fixa',
            title: 'Categoria Fixa',
            p1:
                'Ao realizar essa ação o parceiro deixará de ter uma categoria dinâmica que escala conforme o resultado dele e passará a ter uma categoria fixa.',
            p2:
                'Alterações na categoria também não afetaram esse parceiro, de modo que os valores aplicados serão os que estavam definidos no momento em que a categoria foi fixada.',
            p3:
                'Você é livre para trocar a categoria fixada, caso deseje atualiza-la.',
            p4: 'Deseja confirmar a fixação da categoria ?',
            close: 'Fechar',
            save: 'Confirmar',
            success: 'Categoria fixada com sucesso.',
        },

        storeSupplier: {
            label: 'Cadastrar Fornecedor',
            title: 'Cadastrar Fornecedor',
            p1:
                'Ao realizar essa ação o parceiro será cadastrado como um fornecedor da ConnectPlug.',
            p2: 'Se ele já foi enviado, apenas serão atualizados os dados.',
            p3: 'Deseja confirmar o envio do parceiro para cadastro?',
            close: 'Fechar',
            save: 'Confirmar',
            success:
                'Parceiro enviado para cadastro de fornecedor com sucesso.',
        },

        notifyCustomers: {
            label: 'Notificar Clientes',
            label2: 'Desativar Notificação de Clientes',
            title: 'Notificar Clientes',
            title2: 'Desativar Notificação de Clientes',
            p1:
                'Ao realizar essa ação os clientes do parceiro serão notificados sobre inadimplência.',
            p2: 'Deseja confirmar a notificação dos clientes?',
            p3:
                'Ao realizar essa ação os clientes do parceiro não irão receber mais notificação de inadimplência.',
            p4: 'Deseja DESATIVAR a notificação dos clientes?',
            close: 'Fechar',
            save: 'Confirmar',
            success:
                'Agora os clientes do parceiro serão notificados sobre inadimplência.',
            success2:
                'Agora os clientes do parceiro não irão receber mais notificação de inadimplência.',
        },
        notifyCustomersAll: {
            p1:
                'Ao realizar essa ação os clientes de todos os parceiros serão notificados sobre inadimplência.',
            p2: 'Deseja confirmar a notificação dos clientes?',
            p3:
                'Ao realizar essa ação os clientes de todos os parceiros não irão receber mais notificação de inadimplência.',
            p4: 'Deseja DESATIVAR a notificação dos clientes?',
            success:
                'Agora os clientes de todos os parceiros serão notificados sobre inadimplência.',
            success2:
                'Agora os clientes de todos os parceiros não irão receber mais notificação de inadimplência.',
        },
    },

    resellerUser: {
        resetPassword: {
            label: 'Resetar Senha',
            title: 'Resetar Senha',
            p1: 'Ao executar esta ação um senha temporária será gerada.',
            p2:
                'Essa senha ficará visível para você até que esta janela seja fechada e será enviada ao usuário por e-mail.',
            perform: 'Resetar Senha',
            success: 'Senha temporária gerada com sucesso.',
        },
    },
}
